import { PaymentMethod } from '../../../interfaces/paymentResult';

export const paymentMethodsTitles: Record<PaymentMethod, string> = {
  card: 'Credit Card',
  google_pay: 'Google Pay',
  apple_pay: 'Apple Pay',
};
